import React from "react";

/**
 * Visible file picker aligned with portal inputs (dashed zone + brand Choose file button).
 */
export function PortalFileInput({
  label,
  hint,
  accept,
  disabled,
  multiple,
  onChange,
  className = "",
  inputClassName = "",
  id,
  ...inputProps
}) {
  const inputId = id || (label ? `portal-file-${String(label).replace(/\s+/g, "-").toLowerCase()}` : undefined);

  return (
    <label className={["portal-file-field", className].filter(Boolean).join(" ")} htmlFor={inputId}>
      {label ? <span className="portal-file-field__label">{label}</span> : null}
      <input
        id={inputId}
        type="file"
        className={["portal-file-input", inputClassName].filter(Boolean).join(" ")}
        accept={accept}
        disabled={disabled}
        multiple={multiple}
        onChange={onChange}
        {...inputProps}
      />
      {hint ? <span className="portal-file-field__hint">{hint}</span> : null}
    </label>
  );
}
